import env from 'constants/env';
import { MeiliSearch } from 'meilisearch';

export const meilisearchClient = new MeiliSearch({
  host: env.searchServiceUrl || '',
  apiKey: env.searchServiceApiKey,
});
